import { trigger, state, style, transition, animate, group } from '@angular/animations';

export const CollapseHeightAnimation = trigger('collapseHeight', [
  state('in', style({
    opacity: 1,
    height: '*'
  })),
  transition('void => *', [
    style({
      opacity: 0,
      height: 0
    }),
    animate('0.2s ease-out', style({height: '*'})),
    animate('0.2s', style({opacity: 1}))
  ]),
  transition('* => void', [
    animate('0.2s', style({opacity: 0})),
    animate('0.2s ease-out', style({height: 0}))
  ])
]);


// WEBPACK FOOTER //
// ./src/app/shared/collapse-height.animation.ts